module.exports = __webpack_public_path__ + "static/media/radio-1-hover.cfe636ba.svg";